export default __webpack_public_path__ + "static/media/agentAvatar.c2d98358.svg";